// extracted by mini-css-extract-plugin
module.exports = {"title":"a10a3f92e9--title--BaDnr","row":"a10a3f92e9--row--YZROG","key":"a10a3f92e9--key--ex8Fw","value":"a10a3f92e9--value--kRDEO","warning":"a10a3f92e9--warning--J7CPL"};